<template>
  <StepLayout
    :back="back"
    :save="save"
    :next="next"
    :isEditStepRoute="isEditStepRoute"
    buttonDataEc="envelopes_documents_page"
  >
    <template v-slot:title>
      {{ $t('ui.envelopes.create.steps.documents.title') }}
    </template>

    <FloatingLabelInput
      v-model.trim="title"
      aria-label="title"
      :placeholder="$t('ui.envelopes.create.steps.documents.placeholder')"
      class="max-w-screen-sm"
      data-ec="envelopes_documents_page"
      data-et="name_input"
    />
    <p class="ml-md">{{ $t('ui.envelopes.create.steps.documents.description') }}</p>

    <p class="p-md">!!DOCUMENT SELECTOR GOES HERE!!</p>
  </StepLayout>
</template>

<script setup>
// @ts-check
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import {
  useEnvelope,
  useEnvelopesRoutes,
  useEnvelopesStepsNavigation,
} from '@/composables/envelopes';

import StepLayout from '@/components/layouts/StepLayout';
import FloatingLabelInput from '@/components/tailwind/forms/FloatingLabelInput.vue';

const route = useRoute();

const { envelope } = useEnvelope(route.params.fingerprint);
const { isEditStepRoute } = useEnvelopesRoutes();

// initialise local state
const title = ref(envelope.value.title);

const updateValue = computed(() => ({}));
const isValid = computed(() => true);

// action param is temporary, will be replaced when tanstack query is implemented
const { back, save, next } = useEnvelopesStepsNavigation(
  'envelopes/updateEnvelopes',
  updateValue,
  isValid,
);
</script>
